var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.104 13.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "analytics",
    d: "M39.919,128a2.175,2.175,0,0,0-2.025,2.969l-4.577,4.577a2.168,2.168,0,0,0-1.588,0l-3.272-3.272a2.175,2.175,0,1,0-4.049,0l-5.447,5.447a2.175,2.175,0,1,0,1.231,1.231l5.447-5.447a2.168,2.168,0,0,0,1.588,0l3.272,3.272a2.175,2.175,0,1,0,4.049,0l4.577-4.577a2.175,2.175,0,1,0,.794-4.2Z",
    transform: "translate(-15.992 -128)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboard);
export default __webpack_public_path__ + "static/media/icn_dashboard.adb9a0f0.svg";
export { ForwardRef as ReactComponent };